import { Layout } from 'components/layout'
import { Header } from './header'
import { DownloadBar } from './download-bar'
import { Subscribe } from './subscribe'
import { Releases } from './slider/releases'
import { Casting } from './slider/casting'
import { PreviousSeasons } from './previous-seasons'
import { VideoSection } from './video-section'
import { Map } from './map'

export const Home = () => {
  return (
    <Layout>
      <div>
        <Header />
        <VideoSection />
      </div>
      <Subscribe />
      <Releases />
      <Map />
      <Casting />
      <PreviousSeasons />
      <DownloadBar />
    </Layout>
  )
}
